import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { dropOpportunitySubmit } from '../../actions/dropOpportunity'
import { TextField, RaisedButton } from 'material-ui'
import Header from '../../components/Header/Header'

if (process.env.WEBPACK) {
  require('./DropOpportunity.css')
}

const mapStateToProps = state => ({
  onResponseData: state.onResponseData
})

const mapDispatchToProps = dispatch => {
  return {
    dropOpportunitySubmit: bindActionCreators(dropOpportunitySubmit, dispatch),
    dispatch
  }
}

class DropOpportunity extends Component {
  constructor(props) {
    super(props)
    this.state = {
      opportunityID: ''
    }
  }

  submit() {
    if (this.state.opportunityID && this.state.opportunityID.length != '0') {
      const { dropOpportunitySubmit } = this.props
      dropOpportunitySubmit(parseInt(this.state.opportunityID))
      this.setState({ opportunityID: '' })
    }
  }

  onChange(e) {
    const re = /^[0-9\b]+$/
    if (e.target.value === '' || re.test(e.target.value)) {
      this.setState({ opportunityID: e.target.value })
    }
  }

  render() {
    return (
      <div>
        <Header {...this.props} title='Unified RCM Dashboard' />
        <div className='opportunity-block-wrap'>
          <h3>Drop Opportunity</h3>
          <div className='fieldBlock'>
            <TextField
              floatingLabelText='Opportunity Id'
              type='number'
              value={this.state.opportunityID}
              onChange={this.onChange.bind(this)}
            />
          </div>
          <div className='buttonBlock'>
            <RaisedButton
              label='Submit'
              primary
              onClick={this.submit.bind(this)}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DropOpportunity)



/** WEBPACK FOOTER **
 ** ./src/containers/DropOpportunity/DropOpportunity.js
 **/